import { usePage } from "@inertiajs/inertia-react";
import { Inertia } from "@inertiajs/inertia";
import { useEffect } from "react";
import Cookies from "js-cookie";
import i18n from "../utils/i18n";

export const useLanguageSwitch = () => {
    const {
        props: { flash, user, client, currentLanguage, },
        url,
    } = usePage();

    useEffect(() => {
        if (user?.language) {
            i18n.changeLanguage(user?.language);
        }
    }, [user?.language]);

    const updateLanguage = (language) => {
        const data = { ...user, language: language };
        Cookies.set("lang", language);
        i18n.changeLanguage(language);

        if (user) {
            Inertia.post(route("profile.changeLanguage", data));
            return;
        }

        if(client.key === "amazon") {
            setTimeout(() => {
                window.location.reload();
            }, 100);
            return;
        }

        Inertia.get(url, {
            onError: () => {
                Inertia.reload();
            },
        });
    };

    return {
        updateLanguage,
    };
};
